import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import trans from 'translate';
import FieldsWrapper, { defaultValidationSchema, sharedFields } from '../FieldsWrapper/FieldsWrapper';
import TextField from '../../../../../../../Common/Forms/Fields/TextField';
import Checkbox from '../../../../../../../Common/Checkbox/Checkbox';
import { OrdersContext } from '../../../../../../../Modals/EditTokensModal/EditOrderDetails';
import { getTokenSymbol } from '../../../../../../../../utils/format';

export const enforceMinTokensField = ({
  textFieldProps = {},
  infoHint,
  symbol = '',
  label = 'common.min_value_to_receive',
} = {}) => ({
  name: 'min_tokens_to_receive',
  id: 'min_tokens_to_receive',
  // label: 'common.min_tokens_to_receive',
  label,
  type: 'number',
  className: 'w-100 disabled-field',
  disabled: true,
  infoHint,
  renderField: ({ values, setValues }) => (
    <div className="relative">
      <TextField
        value={`${+(values.min_tokens_to_receive || 0).toFixed(2)} ${values?.tokenSymbol || ''}`}
        disabled
        {...textFieldProps}
      />
      {/* <div
        className="d-flex flex-end gap-md mt-3 align-center pointer"
        onClick={() => setValues((_values) => ({ ..._values, minIsEnforced: !_values.minIsEnforced }))}
      >
        <span className="light-gray-text">{trans('common.enforce_min_tokens_to_receive')}</span>
        <Checkbox defaultChecked={values.minIsEnforced} className="green-border" />
      </div> */}
    </div>
  ),
});

const fields = () => [
  {
    name: 'amount_usd',
    id: 'Amount',
    tag: 'number',
    label: 'common.amount_usd',
    className: 'w-50 fill-at-mobile',
    placeholder: 0,
    inlineHint: <span>$</span>,
    infoHint:
      'Select the amount of USD you wish to invest into the token. The trade will be executed using BNB already in the pool.',
  },
  ...sharedFields,
  enforceMinTokensField({
    label: 'common.min_tokens_to_receive',
    infoHint: 'The minimum amount of tokens that the pool will receive after the trade is executed',
  }),
];

export const calculateMinAmountToRecieve = ({
  amount_usd: amountUsd = 0,
  amount_source: amountSrc = 0,
  price_usd: priceUsd = 0,
  slippage,
}) => {
  const totalAmount = +amountUsd + +amountSrc;
  if (!totalAmount || !priceUsd) return 0;
  const rawValue = (totalAmount / priceUsd).toFixed(2);
  const deductedValue = (rawValue * slippage) / 100;
  return rawValue - deductedValue;
};

export const appendEnforceMinTokens = (values = {}, setValues) => {
  const minToRecieve = calculateMinAmountToRecieve(values);
  setValues((_values) => ({ ..._values, min_tokens_to_receive: minToRecieve }));
};

function LimitBuy({ type }) {
  const validationSchema = {
    ...defaultValidationSchema,
    amount_source: yup.mixed(),
    amount_usd: yup.number().required(' ').typeError(' '),
  };

  const { selectedToken = {} } = useContext(OrdersContext);
  const tokenSymbol = getTokenSymbol(selectedToken)?.toUpperCase();

  return (
    <FieldsWrapper
      initialValues={{ slippage: 2.5, tokenSymbol }}
      validationSchema={validationSchema}
      onValuesChanges={appendEnforceMinTokens}
      fields={fields}
      inlineHint="$"
      type={type}
      submitText="hpool.trade_orders_buy_limit"
    />
  );
}

LimitBuy.propTypes = {
  type: PropTypes.string.isRequired,
};

export default LimitBuy;
